// Which ink — black or white — reads on a chip of a given colour.
//
// Decided by WCAG 2.1 contrast: the ink with the higher contrast ratio
// against the background wins. The backgrounds are the CMS palette
// (CHART_SERIES_COLOR_CHOICES on the backend), which runs from near-white to
// near-black, so neither ink can be fixed.

// A channel linearised out of sRGB gamma, per the WCAG 2.1 definition of
// relative luminance.
const linearChannel = (value) => {
    const channel = value / 255;

    return channel <= 0.04045
        ? channel / 12.92
        : ((channel + 0.055) / 1.055) ** 2.4;
};

const relativeLuminance = (r, g, b) =>
    0.2126 * linearChannel(r) +
    0.7152 * linearChannel(g) +
    0.0722 * linearChannel(b);

// Black's contrast on a background is (L + 0.05) / 0.05 and white's is
// 1.05 / (L + 0.05); they cross at L = sqrt(0.05 * 1.05) - 0.05 ≈ 0.1791,
// above which black reads better.
const BLACK_INK_LUMINANCE = Math.sqrt(0.05 * 1.05) - 0.05;

export const chipInk = (colour) => {
    const hex = (colour || '').replace('#', '');

    if (!/^[0-9a-fA-F]{6}$/.test(hex)) {
        return 'dark';
    }

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return relativeLuminance(r, g, b) >= BLACK_INK_LUMINANCE ? 'dark' : 'light';
};
